import { render, staticRenderFns } from "./OnboardSettingsForm.vue?vue&type=template&id=c93c28fc&scoped=true&"
import script from "./OnboardSettingsForm.vue?vue&type=script&lang=js&"
export * from "./OnboardSettingsForm.vue?vue&type=script&lang=js&"
import style0 from "./OnboardSettingsForm.vue?vue&type=style&index=0&id=c93c28fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93c28fc",
  null
  
)

export default component.exports